module.exports = __webpack_public_path__ + "img/hub_library.f9e625b4.svg";